import {Cancel, Share} from '@mui/icons-material';
import React, { useRef, useState, useEffect, useMemo, useCallback } from "react";
import { useDispatch } from "react-redux";
import { revokeTrafficModal } from "store/wheel/actions";
import { useTraffic } from "store/wheel/selectors";
import { confirmUnshareWidget } from "store/widgets/confirmUnshare";
import styled from "styled-components";
import { find, get, debounce } from "lodash";
import { SPANISH_ITEM_LOWER, SPANISH_ITEM_UPPER } from "utils/config/reference";
import SunEditor from "suneditor-react";

import {
  blockquote,
  align,
  font,
  fontSize,
  fontColor,
  hiliteColor,
  horizontalRule,
  list,
  formatBlock,
  lineHeight,
  paragraphStyle,
  textStyle,
} from "suneditor/src/plugins";
import ResizeAndDragabble from "components/ResizeAndDraggable";
import { useCurrentUser } from "store/users/selectors";
import { useCollectionWidgets } from "utils/methods/firebaseWidgets";
import { v4 } from "uuid";
import { Button as AntdButton } from "antd";
import AccordinButton from "components/AccordinButton";
import { useMobileDetect } from "containers/chat/hooks";
import ClickOutside from "components/OnClickOutside";
import * as Sentry from '@sentry/react';  
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  // min-height: 500px;
  // background-color: rgb(58, 58, 58);
  position: relative;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 0px;
  z-index: 99999999;
  position: fixed;
  cursor: grab;
  // left: 25%;
  //   margin: 15px auto;/
  transform: translate(31%, 0%);

  @media (max-width: 1450px) {
    // width: 96%;
    transform: translate(0%, 0%);
  }
  @media (max-width: 992px) {
    // width: 95%;
    transform: translate(0%, 0%);
  }
`;
const NotebookContainer = styled.div`
  border: 2px solid #009688;
  border-radius: 3px;
  width: 641px;
  height: 350px;
  background-color: white;
  position: relative;
  overflow: visible;
  // display: inline-table;
`;

const FixedToolbarEditorContainer = styled.div`
  .sun-editor,
  .sun-editor .se-wrapper,
  .sun-editor .se-container,
  .sun-editor .se-toolbar-container,
  .sun-editor .se-toolbar {
    overflow: visible !important;
  }

  .sun-editor,
  .sun-editor .se-wrapper,
  .sun-editor .se-container,
  .sun-editor .se-wrapper-wysiwyg {
    position: relative;
    z-index: 1;
  }

  .sun-editor .se-toolbar,
  .sun-editor .se-toolbar-container {
    position: relative;
    z-index: 20;
  }

  .sun-editor .se-submenu,
  .sun-editor .se-list-layer {
    position: absolute !important;
    z-index: 10000 !important;
  }
`;

const BUTTON_LIST = [
  ["font", "fontSize", "formatBlock"],
  ["bold", "underline", "italic", "strike"],
  ["removeFormat"],
  ["fontColor", "hiliteColor"],
  ["outdent", "indent"],
  ["align", "horizontalRule", "list", "table"],
  [
    {
      name: "SPANISH_ITEM_LOWER",
      dataCommand: "SPANISH_ITEM_LOWER",
      buttonClass: "",
      title: `${SPANISH_ITEM_LOWER[0]}`,
      dataDisplay: "submenu",
      innerHTML: `<span>${SPANISH_ITEM_LOWER[0]}</span>`,
    },

    //...
  ],
  [
    {
      name: "SPANISH_ITEM_UPPER",
      dataCommand: "SPANISH_ITEM_UPPER",
      buttonClass: "",
      title: `${SPANISH_ITEM_UPPER[0]}`,
      dataDisplay: "submenu",
      innerHTML: `<span>${SPANISH_ITEM_UPPER[0]}</span>`,
    },
  ],
];
const ACCENT_ROW_SIZE = 3;

const getAccentGridSubmenuHtml = (items, buttonClassName) => {
  const rows = [];
  for (let index = 0; index < items.length; index += ACCENT_ROW_SIZE) {
    const rowItems = items.slice(index, index + ACCENT_ROW_SIZE);
    rows.push(`<div style="display:grid;grid-template-columns:repeat(${rowItems.length}, minmax(28px, auto));gap:6px;">${rowItems
      .map(
        (item) =>
          `<button type="button" class="${buttonClassName}" value="${item}" style="min-width:28px;height:28px;border:1px solid #d9d9d9;border-radius:6px;background:#fff;cursor:pointer;">${item}</button>`
      )
      .join("")}</div>`);
  }

  return `<div class="se-list-inner se-list-font-size" style="width:auto;min-width:126px;"><div style="display:flex;flex-direction:column;gap:6px;padding:8px;">${rows.join("")}</div></div>`;
};

const SPANISH_ITEM_LOWER_PLUGIN = {
  name: "SPANISH_ITEM_LOWER",
  display: "submenu",
  add: function (core, targetElement) {
    let listDiv = this.setSubmenu.call(core);
    var self = this;
    listDiv.querySelectorAll(".se-btn-list-lower").forEach(function (btn) {
      btn.addEventListener("click", self.onClick.bind(core));
    });
    core.initMenuTarget(this.name, targetElement, listDiv);
  },

  setSubmenu: function () {
    const listDiv = this.util.createElement("DIV");
    listDiv.className = "se-submenu se-list-layer";
    listDiv.innerHTML = getAccentGridSubmenuHtml(SPANISH_ITEM_LOWER, "se-btn-list-lower");

    return listDiv;
  },
  onClick: function (e) {
    e.preventDefault()
    const value = e.target.value;
    const node = this.util.createElement("span");
    this.util.addClass(node, "se-custom-tag");
    node.textContent = value;
    this.insertNode(node);
    const zeroWidthSpace = this.util.createTextNode(this.util.zeroWidthSpace);
    node.parentNode.insertBefore(zeroWidthSpace, node.nextSibling);
    this.submenuOff();
  },
};

const SPANISH_ITEM_UPPER_PLUGIN = {
  name: "SPANISH_ITEM_UPPER",
  display: "submenu",
  add: function (core, targetElement) {
    let listDiv = this.setSubmenu.call(core);
    var self = this;
    listDiv.querySelectorAll(".se-btn-list-upper").forEach(function (btn) {
      btn.addEventListener("click", self.onClick.bind(core));
    });
    core.initMenuTarget(this.name, targetElement, listDiv);
  },

  setSubmenu: function () {
    const listDiv = this.util.createElement("DIV");
    listDiv.className = "se-submenu se-list-layer";
    listDiv.innerHTML = getAccentGridSubmenuHtml(SPANISH_ITEM_UPPER, "se-btn-list-upper");

    return listDiv;
  },
  onClick: function (e) {
    const value = e.target.value;
    const node = this.util.createElement("span");
    this.util.addClass(node, "se-custom-tag");
    node.textContent = value;
    this.insertNode(node);
    const zeroWidthSpace = this.util.createTextNode(this.util.zeroWidthSpace);
    node.parentNode.insertBefore(zeroWidthSpace, node.nextSibling);
    this.submenuOff();
  },
};

const WidgetsText = ({ currentClass, sharableWidget }) => {
  const isMobileDevice = useMobileDetect();
  const [editorFocus, setEditorFocus] = useState(false);
  const dispatch = useDispatch();
  const [trafficModal] = useTraffic();
  const currentUser = useCurrentUser();
  const { createCollectionWidgets, updateTextCollectionWidgets } =
    useCollectionWidgets();
  const [text, setText] = useState("");
  const [dimensions, setDimensions] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [showAccordin, setShowAccordin] = useState(true);
  const [isDragging,setIsDragging] = useState(false);

  const trafficData = trafficModal?.widget_menu ?? [];
  const isTeacher = get(currentUser, "role") === "teacher";
  const filterByWidget = find(
    trafficData,
    (item) => item?.menu === "widget_text"
  );
  const displayButtons = isTeacher ? BUTTON_LIST : [];
  const editorDefaultStyle = "text-align: left; height:100%; min-height:127px;";
  const  plugins = [
    blockquote,
    align,
    font,
    fontColor,
    fontSize,
    formatBlock,
    hiliteColor,
    horizontalRule,
    lineHeight,
    list,
    paragraphStyle,
    textStyle,
    SPANISH_ITEM_LOWER_PLUGIN,
    SPANISH_ITEM_UPPER_PLUGIN
  ]
  
  const textFirebaseRef = useRef();
  const filterShareText = useMemo(()=>{
    return find(
      sharableWidget,
      (obj) => obj?.widget_type === "widget_text"
    ) || {};
  },[sharableWidget]);

  useEffect(()=>{
   textFirebaseRef.current = filterShareText
  },[filterShareText])

  const sharedData = useMemo(()=>{
    return filterShareText?.data || {}
  },[filterShareText]);


  const onClose = async () => {
    const shouldClose = await confirmUnshareWidget({
      isShared: filterShareText?.status,
      widgetName: "Text widget",
    });
    if (!shouldClose) return;
    setText("");
    const closeShareData = {
      ...filterShareText,
      status: false,
      data: {},
      message: "widget-text"
    };
    if (filterShareText?.status) {
      createCollectionWidgets(closeShareData);
    }
    await dispatch(revokeTrafficModal(filterByWidget?.id));
  };
  function isHtmlContentSame(a, b) {
    if(!a||!b) return false;
    const normalizeHtml = (html) => {
        return html
            .replace(/<\/?[^>]+(>|$)/g, "") 
            .replace(/\s+/g, " ")          
            .trim();                   
    };
    return normalizeHtml(a) === normalizeHtml(b);
}
  const handleEditorChange = useCallback(debounce((content) => {
    const data = textFirebaseRef?.current;
    if(isHtmlContentSame(content,data?.data?.text)) return;
    if (data?.status) {
      const shareData = {
        ...data,
        data: {
          text: content,
        },
      };
      createCollectionWidgets(shareData);
    }
    setText(content);
  }, 300), []);

  const shareText = () => {
    if (!filterShareText?.status) {
    if (!filterShareText?.id) {
      const shareData = {
        id: v4(),
        class_id: currentClass?.id,
        created_by: currentUser?.id,
        created_at: new Date(),
        widget_type: "widget_text",
        status: true,
        data: {
          text: text,
        },
      };
      createCollectionWidgets(shareData);
    } else {
      const shareData = {
        ...filterShareText,
        status :true,
        data: {
          text: text,
        },
      };
      createCollectionWidgets(shareData);
    }
  } else {
    const unshareData = {
      ...filterShareText,
      status: false,
      data: {},
      message: "widget-text"
    };
    createCollectionWidgets(unshareData);
  }
  
  };

  const updateTextOnShare = useCallback((content) => {
    try {
      setDisabled(true);
      const shareData = {
        ...filterShareText,
        data: {
          text: content ? content : text,
        },
      };
      createCollectionWidgets(shareData);
    } catch (err) {
      Sentry.captureException(`398 Error during updateTextOnShare: ${err}`);
      console.log(err);
    } finally {
      setDisabled(false);
    }
  },[text,filterShareText]);

  const handleTouch = (event) => {
    event.preventDefault();
    onClose();
  };

  const handleTouchEdit = (event) => {
    event.preventDefault();
    handleEditorChange(event);
  };

  const handleTouchShare = (event) => {
    event.preventDefault();
    shareText();
  };

  return (
    <>
      {((filterByWidget?.view && filterByWidget?.menu === "widget_text") ||
        filterShareText?.id) && (
        <Container className="allCheckListSEction wigetsContainer">
             {isMobileDevice && (
        <style>
          {`
            .sun-editor-editable, .sun-editor-editable * {
              // font-size: 24px !important;
              max-font-size: 72px !important;
            }
          `}
        </style>
      )}
          <div  className="mainCheckList">
          <ClickOutside onClickOutside={() => setIsDragging(false) } >
            <ResizeAndDragabble
              defaultValue={{
                x: 150,
                y: 205,
                // width: 270,
                // height: 323,
                width: isTeacher ? 671 : 255,
                height: isTeacher ? 433 : 255,
              }}
              onFocusValue={(()=>{
                  if(isDragging){
                    return isDragging;
                  }else{
                    return editorFocus;
                  }
              })()}
              minHeight={isTeacher ? 336 : 255}
              minWidth={isTeacher ? 270 : 220}
                resize={(data) => {
                  setDimensions(data)
                  setEditorFocus(true);
                }
              }
              showAccordin={showAccordin}
              page={"text"}
            >
              <div
              onTouchStart={(event)=>{
                event.stopPropagation();
                if(!showAccordin){
                  return;
                }
                setIsDragging(true)
              }}
                // className="checkListTopSection"
                className={`checkListTopSection addWidgetSpc ${
                  isDragging && showAccordin ? "widgetMobAndTab" : ""
                }`}
                style={{
                  position: "relative",
                  boxShadow: showAccordin && "rgba(0, 0, 0, 0.2) 0px 2px 4px",
                  width: "100%",
                  height: "100%",
                  // overflowX: "hidden",
                  // overflowY:"hidden",
                  padding: "0px",
                  // overflow: !isTeacher ? "hidden" : "auto"
                  // border: isDragging && "3px solid #002b70"
                }}
              >
                <div
                  className={`checkListFirstTxt widgetFooterGradientOrange bg-blue-10 h-48px pt-17px pb-14px fixed-header-text ${
                    showAccordin ? "br-topLeft-topRight-15px" : "br-20px"
                  } `}
                >
                    <AccordinButton
                      open={showAccordin}
                      onClose={() => {
                        setIsDragging(false);
                        setShowAccordin((prev) => !prev);
                      }}
                      shareableWidget = {sharableWidget}
                      />

                  <span className="text-white text-ft12-700">Text</span>

                  {isTeacher && (
                  <>
                    <div
                      onClick={() => shareText()}
                      onTouchStart={handleTouchShare}
                      style={{
                        marginLeft: "5px",
                        position: "absolute",
                        zIndex: "20",

                        right: "40px",
                        top: "9px",
                      }}
                    >
                      <AntdButton
                        disabled={(() => {
                          if(filterShareText?.status) return;
                          const tempElement = document.createElement("div");
                          tempElement.innerHTML = text;

                          const textContent =
                            tempElement.textContent || tempElement.innerText;
                          return textContent.length === 0;
                        })()}
                        style={{
                          borderRadius: 10,
                          color: "white",
                          backgroundColor: !filterShareText?.status ? "transparent" : "green",
                          border: "0px",
                          height: filterShareText?.status && "26px",
                          transition: "all 0.3s ease-in-out",
                          transformOrigin: "center",
                          cursor: filterShareText?.status ? "default" : ""
                        }}
                      >
                          <Share style={{ color: "white", fontSize: 16 }} />
                      </AntdButton>
                    </div>
                  </>
                )}


                  {isTeacher && (
                  <Cancel
                    onPointerDown={() => onClose()}
                    // onTouchStart={handleTouch}
                    style={{
                      marginLeft: "5px",
                      position: "absolute",
                      right: 17,
                      top: 13,
                      fontSize: 18,
                      color: "red",
                      background: "white",
                      borderRadius: 20,
                      cursor: "pointer",
                    }}
                  />
                )}
                </div>
              
               
                {showAccordin && (
                  <div  
                      onMouseEnter={() => {
                        setEditorFocus(true)
                       }}
                      onMouseLeave={() => {
                        setEditorFocus(false) 
                      }} 
                  style={{ 
                     paddingRight: "25px",
                     paddingLeft: "14px",
                     paddingBottom: "33px",
                     paddingTop: "58px",
                      }}>
                    <NotebookContainer
                      style={{
                          width: Math.max((dimensions?.width ?? 641) - 30, 0),
                          height: Math.max((dimensions?.height ?? 350) - 100, 0),
                          position: "relative",
                          overflowX: "hidden"
                      }}
                      className="widget-text-note"
                    >
                      <FixedToolbarEditorContainer>                      
                        {sharedData?.text ? (
                          <SunEditor
                            onChange={handleEditorChange}
                            onTouchStart={handleTouchEdit}              
                            setContents={sharedData?.text ? sharedData?.text : text}
                            height="100%"
                            placeholder={isTeacher ? "Please type here..." : ""}
                            setOptions={{
                              height: "100%",
                              width: "100%",
                              showPathLabel: false,
                              buttonList: displayButtons,
                              plugins: plugins,
                              stickyToolbar: false
                            }}
                            setDefaultStyle={editorDefaultStyle}
                            style={{ color: "#000000", transform: "none", boxSizing: "border-box" }}
                            disable={!isTeacher ? true : false}
                          />
                        ) : (
                          <SunEditor
                            onChange={handleEditorChange}
                            onTouchStart={handleTouchEdit}
                            setContents={text}
                            height="100%"
                            placeholder={isTeacher ? "Please type here..." : ""}
                            setOptions={{
                              height: "100%",
                              width: "100%",
                              showPathLabel: false,
                              buttonList: displayButtons,
                              plugins:plugins,
                              stickyToolbar: false
                            }}
                            setDefaultStyle={editorDefaultStyle}
                            style={{ color: "#000000",transform: "none", boxSizing: "border-box" }}
                            disable={!isTeacher ? true : false}
                          />
                        )}
                      </FixedToolbarEditorContainer>
                    </NotebookContainer>
                  </div>
                )}
                { showAccordin && (
                <div className="widgetFooter widgetFooterGradientOrange"><label>Widget</label></div>
                )}
              </div>
            </ResizeAndDragabble>
            </ClickOutside>
          </div>
        </Container>
      )}
    </>
  );
};

export default React.memo(WidgetsText);